import {
  FaUser,
  FaArrowLeft,
  FaTrophy,
  FaCheckCircle,
  FaShieldAlt,
  FaClock,
  FaCreditCard,
} from "react-icons/fa";
import Button from "../../../../ReusableComponent/Button";

const Step2ReviewPayment = ({ onBack, onNext }) => {
  // Dummy Data
  const personalInfo = [
    { label: "Full Name", value: "Krati Porwal" },
    { label: "Email", value: "porwalkrati095@gmail.com" },
    { label: "Phone", value: "7987525391" },
    { label: "Experience", value: "Beginner", badge: true },
  ];

  const academicInfo = [
    { label: "University", value: "Medicaps University" },
    { label: "Graduation Year", value: "2026" },
    { label: "Location", value: "Indore, India" },
    { label: "T-shirt Size", value: "M", badge: true },
  ];

  const tournamentInfo = [
    {
      label: "Tournament Name",
      value: "International Coding Championship 2024",
    },
    { label: "Registration Deadline", value: "March 15, 2024" },
    { label: "Max Participants", value: "5,000" },
    { label: "Current Registrations", value: "3,247", highlight: true },
  ];

  const packageInfo = {
    fee: "$25",
    discount: "-$5.00",
    total: "$20",
    features: [
      "Official Tournament T-shirt",
      "Digital Certificate",
      "Access to recorded sessions",
      "Networking opportunities",
      "Career fair access",
    ],
  };

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        {/* Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-10 text-center">
            <h2 className="fw-bold text-light mb-3">
              Review & Complete Payment
            </h2>
            <p className="text-muted">
              Verify your information and secure your tournament spot
            </p>
          </div>
        </div>

        <div className="row g-4">
          {/* Left Section */}
          <div className="col-md-8">
            {/* Registration Summary */}
            <div className="card bg-dark border-primary mb-4">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex align-items-center">
                    <div className="rounded-circle bg-primary p-2 me-3">
                      <FaUser className="text-white" />
                    </div>
                    <div>
                      <h4 className="text-light mb-1">Registration Summary</h4>
                      <small className="text-primary">
                        Review your details before payment
                      </small>
                    </div>
                  </div>
                  <Button variant="back">
                    <FaArrowLeft className="me-1" /> Edit
                  </Button>
                </div>

                <div className="row g-4">
                  {/* Personal Information */}
                  <div className="col-md-6">
                    <div className="bg-dark p-3 rounded-3 border border-secondary">
                      <h6 className="text-primary fw-semibold mb-3">
                        Personal Information
                      </h6>
                      {personalInfo.map((item, idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between align-items-center py-1 small"
                        >
                          <span className="text-muted">{item.label}</span>
                          {item.badge ? (
                            <span className="badge bg-primary">
                              {item.value}
                            </span>
                          ) : (
                            <span className="text-light fw-medium">
                              {item.value}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Academic & Location */}
                  <div className="col-md-6">
                    <div className="bg-dark p-3 rounded-3 border border-secondary">
                      <h6 className="text-info fw-semibold mb-3">
                        Academic & Location
                      </h6>
                      {academicInfo.map((item, idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between align-items-center py-1 small"
                        >
                          <span className="text-muted">{item.label}</span>
                          {item.badge ? (
                            <span className="badge bg-secondary">
                              {item.value}
                            </span>
                          ) : (
                            <span className="text-light fw-medium">
                              {item.value}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tournament Info */}
            <div className="card bg-dark border-info mb-4">
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle p-2 me-3 bg-info bg-opacity-25">
                    <FaTrophy className="text-info" />
                  </div>
                  <div>
                    <h4 className="text-light mb-1">Tournament Information</h4>
                    <small className="text-info">
                      Competition details and schedule
                    </small>
                  </div>
                </div>

                <div className="row g-3">
                  {tournamentInfo.map((item, idx) => (
                    <div key={idx} className="col-md-6">
                      <div className="bg-dark bg-opacity-50 p-3 rounded-3">
                        <span className="text-muted small d-block">
                          {item.label}
                        </span>
                        <p
                          className={`fw-semibold mb-0 ${
                            item.highlight ? "text-success" : "text-light"
                          }`}
                        >
                          {item.value}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Payment */}
          <div className="col-md-4">
            <div className="card bg-dark border-primary border-2 shadow-sm">
              <div className="card-body p-4 text-center ">
                <div className="d-flex justify-content-center">
                <div className="rounded-circle bg-primary mb-3 d-flex justify-content-center align-items-center" style={{ width: 60, height: 60 }}>
                  <FaTrophy className="text-white fs-4" />
                </div>
                </div>
                <h4 className="text-light fw-bold">Tournament Package</h4>
                <p className="text-primary small">
                  Premium registration benefits
                </p>

                {/* Pricing */}
                <div className="bg-dark p-3 rounded-3 mb-4">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Registration Fee</span>
                    <span className="text-decoration-line-through text-muted">
                      {packageInfo.fee}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between text-success mb-3">
                    <span>Early Bird Discount</span>
                    <span>{packageInfo.discount}</span>
                  </div>
                  <hr className="border-secondary" />
                  <div className="d-flex justify-content-between">
                    <span className="h5 text-light fw-bold">Total</span>
                    <span className="h4 text-primary fw-bold">
                      {packageInfo.total}
                    </span>
                  </div>
                </div>

                {/* Features */}
                <div className="mb-4 text-start">
                  <h6 className="text-light fw-bold mb-3">
                    <FaCheckCircle className="text-success me-2" />
                    What's Included
                  </h6>
                  {packageInfo.features.map((f, idx) => (
                    <div key={idx} className="d-flex align-items-center mb-2">
                      <FaCheckCircle className="text-success me-2 small" />
                      <span className="text-light small">{f}</span>
                    </div>
                  ))}
                </div>

                {/* Payment Button */}
                <Button
                  variant="gradient"
                  fullWidth
                  onClick={onNext}
                >
                  <FaCreditCard className="me-2" /> Secure Payment{" "}
                  {packageInfo.total}
                </Button>

                {/* Security Info */}
                <div className="text-muted mt-3 small d-flex align-items-center justify-content-center">
                  <FaShieldAlt className="me-2" /> 256-bit SSL Encryption
                </div>
                <div className="text-success small mt-1">
                  <FaCheckCircle className="me-1" /> PCI DSS Compliant
                </div>
              </div>
            </div>

            {/* Offer */}
            <div className="card border-warning mt-4">
              <div className="card-body p-3">
                <div className="d-flex align-items-center mb-2">
                  <FaClock className="text-warning me-2" />
                  <span className="fw-bold text-warning">
                    Limited Time Offer
                  </span>
                </div>
                <p className="text-warning small mb-2">
                  Early bird pricing ends in <strong>5 days</strong>
                </p>
                <div className="progress" style={{ height: 4 }}>
                  <div
                    className="progress-bar bg-warning"
                    style={{ width: "75%" }}
                  ></div>
                </div>
                <small className="text-muted">
                  Save {packageInfo.discount} by registering today!
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="row mt-5">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Button variant="back" onClick={onBack}>
              <FaArrowLeft className="me-2" /> Back to Details
            </Button>
            <div className="text-center">
              <div className="text-warning small d-flex align-items-center justify-content-center">
                <FaClock className="me-1" /> Registration closes in 5 days
              </div>
              <div className="text-muted small mt-1">1753 spots remaining</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step2ReviewPayment;
